import styled from 'styled-components'

export const BlogPostCardWrapper = styled.a`
  background: #ffffff;
  width: ${props => (props.huge ? '100%' : '32%')};
  margin-bottom: 36px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: ${props => (props.huge ? 'row' : 'column')};
  align-items: flex-start;
  cursor: pointer;
  position: relative;

  @media (max-width: 768px) {
    flex-direction: ${props => (props.huge ? 'column' : 'row')};
    height: auto;
    margin: 0 16px 12px;
    width: calc(100% - 32px);
  }
`

export const BlogPostCardImage = styled.img`
  width: ${props => (props.huge ? '66%' : '100%')};
  height: ${props => (props.huge ? '492px' : '234px')};
  object-fit: cover;
  ${props =>
    props.placeholder &&
    `
    background: #fafafa;
    content: '';
  `}

  @media (max-width: 768px) {
    width: ${props => (props.huge ? '100%' : '50%')};
    height: ${props => (props.huge ? '234px' : '128px')};
  }
`

export const BlogPostCardContent = styled.div`
  flex: 1;

  ${props =>
    props.huge
      ? `
  padding-top: 60px;
  padding-left: 42px;
  `
      : `
    padding: 14px;
  `}

  @media (max-width: 768px) {
    padding: ${props => (props.huge ? '11px 0' : '0 0 0 7px')};
  }
`

export const BlogPostCardDateTime = styled.span`
  display: block;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #828282;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`

export const BlogPostCardCategoryTitle = styled.span`
  display: block;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: #828282;
  text-transform: uppercase;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`

export const BlogPostCardAuthor = styled.div`
  display: block;
  color: black;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0.01em;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`

export const AuthorName = styled.span`
  color: #ff5e6d;
`

export const BlogPostCardTitle = styled.span`
  display: block;
  color: #000000;
  margin-top: 10px;
  margin-bottom: 10px;
  font-weight: 500;

  ${props =>
    props.huge
      ? `
    font-size: 40px;
  line-height: 49px;
  `
      : `
  font-size: 24px;
  line-height: 29px;
  `}

  @media (max-width: 768px) {
    font-size: ${props => (props.huge ? '24px' : '16px')};
    line-height: ${props => (props.huge ? '29px' : '20px')};
    margin-top: 0;
    margin-bottom: 0;
  }
`

export const SharePostIcon = styled.img`
  width: 18px;
`

export const SharePostButton = styled.button`
  position: absolute;
  top: 14px;
  right: 14px;
  border: none;
  background: transparent;
  opacity: 0.5;

  &:hover {
    opacity: 1;
  }
`
